module.exports = __webpack_public_path__ + "static/media/wedo.5ab247fe.jpg";